import {types} from './types';

const initialState = {
    list: [],
    view: {
        type: '',
        link: ''
    }
}

export function messangerReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_MESSANGER:
            return { ...state, list: action.payload};
        case types.SET_VIEW_MESSANGER:
            return { ...state, view: action.payload};
        default:
            return state
    }
}